import Hero from "@/components/landing/Hero";
import LandingStatsStrip from "@/components/landing/LandingStatsStrip";
import ComplianceBadges from "@/components/landing/ComplianceBadges";
import CryptoUpdates from "@/components/landing/CryptoUpdates";
import WhyChoose from "@/components/landing/WhyChoose";
import LandingProducts from "@/components/landing/LandingProducts";
import OtcDesk from "@/components/landing/OtcDesk";
import EndlessPossibilities from "@/components/landing/EndlessPossibilities";
import MultiplePossibilities from "@/components/landing/MultiplePossibilities";
import JoinBanner from "@/components/landing/JoinBanner";
import FreeYourMoney from "@/components/landing/FreeYourMoney";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-cm-navy font-sans antialiased">
      <Hero />
      <LandingStatsStrip />
      <ComplianceBadges />
      <CryptoUpdates />
      <WhyChoose />
      <LandingProducts />
      <OtcDesk />
      <EndlessPossibilities />
      <MultiplePossibilities />
      <JoinBanner />
      <FreeYourMoney />
      <Footer />
    </main>
  );
}
